const context = require.context(
    "./",
    false,
    /\.(png|jpe?g|svg|jfif)$/
);

const images = context.keys().map(context);

export default images;